import { VideoRenderDto } from "@repo/api/video-render";
import { ShareLinkStatus } from "./ShareLinkCard";

export function getStatus(videoRender: VideoRenderDto | null): ShareLinkStatus {
  if (!videoRender) {
    return "generating";
  }

  if (videoRender.status === "failed") {
    return "failed";
  }

  switch (videoRender.shareInfo?.status) {
    case "done":
      return "done";
    case "failed":
      return "failed";
    default:
      return "generating";
  }
}

export function getTitle(status: ShareLinkStatus) {
  if (status === "failed") {
    return "Couldn't create share link";
  }

  if (status === "done") {
    return "Your share link is ready";
  }

  return "Creating your video...";
}

export function getDescription(
  status: ShareLinkStatus,
  videoRender: VideoRenderDto | null,
): string {
  if (status === "failed") {
    return videoRender?.status === "failed"
      ? "The video export failed. Try exporting again."
      : "Please try again.";
  }

  if (status === "done") {
    return "You can now share the link with others.";
  }

  return "Your share link will be ready shortly.";
}
